import React from "react";
import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";

const ModalHeaderContainer = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    justify-content: space-between;
    align-items: flex-start;
    gap: ${p => p.gap || "1rem"};
    width: ${p => p.width || "100%"};
    max-width: ${p => p.maxWidth};
    margin-bottom: 0;
    padding: 1.5rem 1.6rem 1.2rem;
    box-sizing: border-box;
    background: transparent;
    border-bottom: 1px solid ${portalColors.border};

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
        align-items: stretch;
        padding: 1.25rem;
    }
`;

const ModalHeaderText = styled.div`
    min-width: 0;
`;

const ModalTitle = styled.h2`
    color: ${portalColors.text};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 1.75rem;
    line-height: 1.1;
    font-weight: 800;
    margin: 0;
    overflow-wrap: anywhere;

    @media (max-width: 600px) {
        font-size: 1.5rem;
    }
`;

const ModalDescription = styled.p`
    color: ${portalColors.mutedText};
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.875rem;
    line-height: 1.5;
    font-weight: 500;
    margin: 0.45rem 0 0;
    max-width: 42rem;
    overflow-wrap: anywhere;
`;

const ModalHeaderActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 0.75rem;

    @media (max-width: 760px) {
        justify-content: flex-start;

        > * {
            width: 100%;
            max-width: 100%;
        }
    }
`;

const ModalHeader = (props) => {
    const { title, description, children } = props;

    return (
        <ModalHeaderContainer maxWidth="98.625rem">
            <ModalHeaderText>
                <ModalTitle>{title}</ModalTitle>
                {description && <ModalDescription>{description}</ModalDescription>}
            </ModalHeaderText>

            {children && <ModalHeaderActions>{children}</ModalHeaderActions>}
        </ModalHeaderContainer>
    );
};

export default ModalHeader;
